import { cn } from "@/lib/utils"

/**
 * Agent column: the prompt field frame (label row + empty pe-editor box) stays on screen
 * while the shot loads, so only the content inside changes.
 */
export function PromptFieldLoadingFrame({
  label,
  message,
  className,
}: {
  label: string
  message?: string | null
  className?: string
}) {
  return (
    <div className={cn("flex min-h-[140px] min-w-0 flex-1 flex-col", className)}>
      <div className="flex h-7 shrink-0 items-center">
        <span className="text-[11px] font-semibold tracking-wide text-ui-text-muted uppercase">{label}</span>
      </div>
      <div className="pe-editor mt-1.5 flex min-h-0 flex-1 items-center justify-center text-sm text-ui-text-secondary">
        {message}
      </div>
    </div>
  )
}
